import { ReplayHighlight } from "src/features/events/model/replay-highlight";
import { createSlice } from "@reduxjs/toolkit";
import { HighlightEvent } from "./model/HighlightedProduct";
import { RootState } from "src/shared/store";

let store: any;
export const injectStore = (_store: any) => {
  store = _store;
};

export interface HighlightedProductState {
  item: HighlightEvent[];
  status: "pending" | "fulfilled" | "rejected";
  replayHighlightData: ReplayHighlight[];
  liveHighlightData: HighlightEvent[];
}

const initialState: HighlightedProductState = {
  item: [],
  replayHighlightData: [],
  liveHighlightData: [],
  status: "pending",
};

export const highlightedProductSlice = createSlice({
  name: "highlightedProduct",
  initialState,
  reducers: {
    reset: (state) => {
      state.item = [];
    },
    setReplayHighlightData: (state, action) => {
      state.replayHighlightData = action.payload;
    },
    setLiveHighlightData: (state, action) => {
      state.liveHighlightData = action.payload;
    },
  },
});

export const { reset, setReplayHighlightData, setLiveHighlightData } =
  highlightedProductSlice.actions;

export const replayHighlightDataSelector = (state: RootState) =>
  state.highlightedProduct.replayHighlightData;

export const liveHighlightDataSelector = (state: RootState) =>
  state.highlightedProduct.liveHighlightData;

export default highlightedProductSlice.reducer;
